<template>
  <v-btn small @click="$emit('click')" class="btn-delete m-1">
    <i class="fas fa-trash mr-2 text-twenty"></i>
    REMOVER
  </v-btn>
</template>

<script>
export default {
  name: "VDataTableDeletetButton",
};
</script>

<style>
</style>